import React from 'react';
import Icon from '../AppIcon';

const Pagination = ({ page, totalPages, totalCount, pageSize, onPageChange, isLoading }) => {
  if (!totalPages || totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalCount);

  const getPageNumbers = () => {
    const delta = 2;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - delta && i <= page + delta)) {
        pages.push(i);
      }
    }
    const result = [];
    let prev = null;
    for (const p of pages) {
      if (prev !== null && p - prev > 1) result.push('ellipsis');
      result.push(p);
      prev = p;
    }
    return result;
  };

  return (
    <div className="flex items-center justify-between px-4 py-3">
      <p className="text-xs text-foreground hidden sm:block">
        {start}–{end} of {totalCount}
      </p>
      <div className="flex items-center gap-1 mx-auto sm:mx-0">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1 || isLoading}
          className="w-8 h-8 rounded-lg flex items-center justify-center border border-border text-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <Icon name="ChevronLeft" size={15} />
        </button>

        {getPageNumbers().map((p, i) =>
          p === 'ellipsis' ? (
            <span key={`e${i}`} className="w-8 text-center text-xs text-foreground select-none">…</span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              disabled={isLoading}
              className={`w-8 h-8 rounded-lg text-xs font-semibold transition-colors disabled:cursor-not-allowed ${
                p === page
                  ? 'bg-primary text-primary-foreground'
                  : 'border border-border text-foreground hover:bg-muted'
              }`}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages || isLoading}
          className="w-8 h-8 rounded-lg flex items-center justify-center border border-border text-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <Icon name="ChevronRight" size={15} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
